module.exports = __webpack_public_path__ + "img/pro_rcfw2.7c61275a.png";